import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-form-altrerisoluzionilavoro-view',
  templateUrl: './form-altrerisoluzionilavoro-view.component.html',
  styleUrls: ['./form-altrerisoluzionilavoro-view.component.css']
})
export class FormAltrerisoluzionilavoroViewComponent {

  @Input() ctxBodyFascicolo;
  constructor() {}
}
